export const initialTestContent = `
<style>
   a {
     color: blue !important;
   }
</style>

<pcn-page-menu class="sticky-top" wrap>
  <pcn-link href="browse/search">
    P Basket
  </pcn-link>

  <pcn-link href="browase/product-lists" new-tab="true">
    My lists
  </pcn-link>
</pcn-page-menu>

<div class="row">
  <div class="col position-relative">
    <pcn-media style="max-height: 50vh" 
      src="https://epicurobestsellertestimages.epicurotesting.com/images/static/dogancan_arabaci/86d778d46c014c34b7a79bc9712ef709.jpg" 
      object-position="100% 25%"
    >
    </pcn-media>
    <div style="position: absolute; left: 5%; top: 40%; right: 40%;">
      <h2 style="backdrop-filter: blur(6px);"><strong>New Season is here!</strong></h2>
      <p style="backdrop-filter: blur(6px);">Shop the latest season full of colors and bright textures.</p>
      <button class="btn" style="background-color: black; color: white">
        <pcn-link href="browse/search">SHOP NEW SEASON</pcn-link>
      </button>
    </div>
  </div>
</div>

<div class="row">
  <div class="col position-relative">
    <pcn-media style="max-height: 50vh" 
      src="https://epicurobestsellertestimages.epicurotesting.com/images/static/dogancan_arabaci/07774a2eca784e89b003268b100e4c02.jpg"
      xs-src="https://epicurobestsellertestimages.epicurotesting.com/images/static/dogancan_arabaci/fd25c8f90d63440d9d455f1c71d06c03.jpg"
    >
    </pcn-media>
    <div style="position: absolute; color: white; left: 55%; top: 40%; right: 5%; display: flex; flex-direction: column; align-items:center;">
      <h2 style="backdrop-filter: blur(6px);"><strong>Flowly Dresses</strong></h2>
      <p style="backdrop-filter: blur(6px);">Shop the latest season.</p>
      <button class="btn" style="background-color: black; color: white">
        <pcn-link href="browse/search">SHOP LATEST PIECES</pcn-link>
      </button>
    </div>
  </div>
</div>

<div class="row">
  <div class="col-xs-12 col-md-6 col-lg-4">
    <pcn-media style="max-height: 40vh" 
      src="https://www.youtube.com/watch?v=e-Wp9neRfQc&ab_channel=BESTSELLERA%2FS"
      media-type="youtube"
      autoplay="true"
    >
  </div>

  <div class="col-xs-12 col-md-6 col-lg-4">
    <pcn-media style="max-height: 40vh" 
      src="https://epicurobestsellertestvideos.epicurotesting.com/static/JJ/46ad73a8bbc8417890cfc8183da80a68.mp4"
      media-type="video"
      object-fit="cover"
      controls="true"
    >
  </div>

  <div class="col-xs-12 col-md-12 col-lg-4">
    <pcn-media style="max-height: 40vh" 
      src="https://vimeo.com/288526986"
      media-type="vimeo"
      object-fit="cover"
    >
  </div>
</div>

<div class="row">
  <pcn-pcards max-products="1" md-max-products="3" lg-max-products="6" query="preset=any&sortField=Default&sortDirection=Asc" lg-rows-enabled></pcn-pcards>
</div>
`;
